import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Tab from "../components/tab";
import {
  personal_information,
  sendOtp,
  returnHome,
  send_otp_loading,
  sendMailOtp, 
  verifyMailOtp, 
  verifyMail_otp_loading

} from "../../../Redux/ActionCreator";
import { ToastContainer, toast } from "react-toastify";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import PhoneVerificatioModal from "../../common/phone_verification_modal";
import EmailVerificationModal from "../../common/email_verification_modal";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { capitalizeWords, capitalize } from "../../../utils/capitalize/capitalizeWord";
import countryData from 'country-data';
import CustomSelect from "../../common/custom_select";

export default function PersonalInfoPage3({ nextStep, prevStep }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const info = useSelector((info) => info.personal_info);
  const profile = useSelector((e) => e.login);
  const userInfo = useSelector((e) => e.userInfo);
  const secret = useSelector((prev) => prev.secret);
  const p_profile = useSelector((e) => e.profile);
  const existingResume = useSelector(e => e.existingCV);
  const send_otp = useSelector((state) => state.send_otp);
  const verify_otp = useSelector(state => state.otp);
  const send_mail_otp = useSelector((state) => state.sendmailOtp);
  const verify_mail_otp = useSelector(state => state.verifyMailOTP);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  const [verifyModal, setVerifyModal] = useState(false);
  const [resendTimed, setResendTimed] = useState(false);

  const [verifyMailModal, setVerifyMailModal] = useState(false);
  const [resendMailTimed, setResendMailTimed] = useState(false);

  let [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [showPhone, setShowPhone] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);

  useEffect(() => {
    if (info.message !== null) {
      // get the first and lastname only
      let infoPhoneNumber = userInfo.user?.phone_number_verified == true ? userInfo.user?.phone_number : info.message?.Phone_number;
      let infoEmail = info.message?.Email
      setPhone(infoPhoneNumber !== undefined ? infoPhoneNumber : "");
      setEmail(infoEmail !== undefined ? infoEmail : "");
    } else {
      let cacheInfo = getOneFromServerCache("personalInfo")
      cacheInfo.then(res => res.json())
        .then(res => {
          console.log("server cache value", res);
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(personal_information(resObj));
              setPhone(resObj?.Phone_number);
              setEmail(resObj?.Email);
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch(err => {
          // console.log("Error getting personal info", err)
        })
    }

    if (userInfo.user !== null && userInfo.user?.Confirmed == true) {
      setEmail(userInfo.user?.email)
    }
  }, []);

  // useEffect(() => {
  //   if (userInfo.user !== null && userInfo.user?.Confirmed == true) {
  //     console.log("get here")
  //     setEmail(userInfo.user?.email)
  //   }
  // }, []);


  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const showPhoneTimeout = setTimeout(() => setShowPhone(true), 2500); // Matches Typewriter speed

    return () => clearTimeout(showPhoneTimeout);
  }, []);

  useEffect(() => {
    if (phone !== "" && showPhone == true) {
      // Show last name label and input once first name is being typed
      const showEmailTimeout = setTimeout(() => setShowEmail(true), 800);

      return () => clearTimeout(showEmailTimeout);
    }
  }, [phone, showPhone]); // Runs only when firstName 
  
  useEffect(() => {
    if (email !== "" && showEmail == true) {
      // Show last name label and input once first name is being typed
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 400);

      return () => clearTimeout(showButtomBTNTimeout);
    }
  }, [email, showEmail]); // Runs only when firstName updates

  /* Moving section */
  const handlePrev = () => {
    prevStep();
  }

  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    // if (userInfo.user?.phone_number_verified == false && phone.includes("+")) {
    //   handleSendVerification();
    // } else 
    if (userInfo.user?.Confirmed == false) {
      handleSendMailVerification();
    } else {
      try {
        console.log('email', email, "phone number ", phone)
        if (
          phone !== "" && email !== "" /* userInfo.user?.phone_number_verified == true && phone !== "" && phone?.length > 10 && email !== "" */
        ) {
          let personalInformation = {
            Firstname: info.message?.Firstname,
            LastName: info.message?.LastName,
            Address: info.message?.Address,
            Phone_number: phone,
            Email: email,
            JobInterests: info.message?.JobInterests,
          };
          dispatch(personal_information(personalInformation));
          // save into server cache
          await saveIntoServerCache("personalInfo", personalInformation);
          nextStep();
        } else {
          setTimeout(() => {
            toast.error("Phone number and email is required", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }, 50);
        }
      } catch (error) {
          throw error
      }
    }
    
  }

  const handleSendVerification = () => {
    // e.preventDefault();
    const final_num = phone;
    if (final_num.includes("+") && final_num?.length > 10) {
      resendTimed === false && setResendTimed(true);
      verifyModal === false && setVerifyModal(true);
      // console.log(final_num);
      dispatch(sendOtp(String(final_num)));

      if (send_otp.errMess !== null) {
        setTimeout(() => {
          toast.error(send_otp.errMess, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);

        dispatch(send_otp_loading());
      }
    } else {
      if (final_num?.length < 12) {
        setTimeout(() => {
          toast.error("Phone number must be  digit", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      } else {
        setTimeout(() => {
          toast.error("Please add your country code e.g +1, +2, +45", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      }
      
    }
  };

  const handleSendMailVerification = () => {
    // e.preventDefault();
    const final_num = phone;
    if (final_num.includes("+")) {
      resendMailTimed === false && setResendMailTimed(true);
      verifyMailModal === false && setVerifyMailModal(true);
      // console.log(final_num);
      dispatch(sendMailOtp(email));

      if (send_mail_otp.errMess !== null) {
        setTimeout(() => {
          toast.error(send_mail_otp.errMess, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
        dispatch(verifyMail_otp_loading());
      }
    } else {
      setTimeout(() => {
        toast.error("Please enter a valid mail", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    }
  };

  /* Flag section start */
  const [disable, setDisable] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [countryCodeCountry, setCountryCodeCountry] = useState("");
  let [inputValue, setInputValue] = useState(countryCode);

  // get te country codes data
  const countryCodes = countryData.callingCountries.all.map((country) => ({
    code: `${country.countryCallingCodes[0]}`,
    alpha2: country.alpha2,
    name: country.name
  }));

    
  const handleInputChange = (e) => {
    
    localStorage.setItem("phone_number", e.target.value);
    let newValue = e.target.value;
    if (newValue.includes(countryCode)) {
      setInputValue(newValue);
      setPhone(newValue)
    } else {
      setInputValue(countryCode);
      setPhone(countryCode);
    }
  }

  useEffect(() => {
    // console.log(info);
    if (info?.message !== null || info?.message?.Phone_number?.includes('+')) {
      let country_code = getOneFromServerCache("country_code");
      let country_code_country = getOneFromServerCache("country_code_country");

      country_code.then(resp => resp.json()).then(res => {
        if (res.success == true) {
          if (res.data !== null && res.data !== undefined) {
            let response = JSON.parse(res.data);
            console.log("respObj", response);
            setCountryCode(response);
          } else {
            setCountryCode("+1");
          }
        } else if (res.success === false && res.message == "Unauthorized") {
          dispatch(returnHome(res.status));
        }
      })

      country_code_country.then(resp => resp.json()).then(res => {
        if (res.success === true) {
          if (res.data !== null && res.data !== undefined) {
            let response = JSON.parse(res.data);
            console.log("respObj", response);
            setCountryCodeCountry(response);
          } else {
            setCountryCodeCountry("United States");
          }
        } else if (res.success === false && res.message == "Unauthorized") {
          dispatch(returnHome(res.status));
        }
      })
    }
    else {
      setCountryCode("+1");
      setCountryCodeCountry("United States");
    }
  }, [info]);

  useEffect(() => {
    if (userInfo.user?.phone_number_verified == false) {
      AddCountryCode(countryCode);
    }
  }, [countryCode]);

  const AddCountryCode = (code) => {
    setPhone(code);
    phone = code;
  }

  const handleSelectCountryCode = (code) => {
    setCountryCode(code);
    setInputValue(code);
  }

  const hanldeSetCountryCodeCountry = (country) => {
    setCountryCodeCountry(country);
  }

  /* Flag section ends */

  const verificationModal =
  send_otp.errMess === null && verifyModal && verify_otp.message === null
    ? createPortal(
      <div className="top-0 left-0 fixed bottom-0 right-0 z-10 h-screen flex justify-center items-center bg-black bg-opacity-70 backdrop-blur-[2px] ">
        <PhoneVerificatioModal
          resendCode={() => resendTimed === false && setResendTimed(true)}
          waitingEnded={() => resendTimed && setResendTimed(false)}
          resendTimed={resendTimed}
          phoneNumber={phone}
          removeModal={() => verifyModal === true && setVerifyModal(false)}
        />
      </div>,
      document.getElementById("modal")
    )
    : null;

    const MailverificationModal =
    send_mail_otp.errMess === null && verifyMailModal && verify_mail_otp.message === null
      ? createPortal(
        <div className="top-0 left-0 fixed bottom-0 right-0 z-10 h-screen flex justify-center items-center bg-black bg-opacity-70 backdrop-blur-[2px] ">
          <PhoneVerificatioModal
            resendCode={() => resendMailTimed === false && setResendMailTimed(true)}
            waitingEnded={() => resendMailTimed && setResendMailTimed(false)}
            resendTimed={resendMailTimed}
            email={email}
            removeModal={() => verifyMailModal === true && setVerifyMailModal(false)}
          />
        </div>,
        document.getElementById("modal")
      )
      : null;

  return (
    <>
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center ">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md p-6 md:p-8`}>
        
        {/* Tabs Section */}
        <div className="flex justify-center w-full">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <Tab label="Personal Information" current={true} completed={false} num="1" />
            <Tab num="2" current={false} label="Experience" completed={false} />
            <Tab num="3" current={false} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        {/* Input Section with Animations */}
        <div className="flex justify-center w-full">
          <div className="flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center">
            
            <motion.p 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut" }} 
              className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold notranslate"
            >
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["Entendido. ¿Cuál es el mejor número de teléfono y correo electrónico para contactarte?"]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Got it. What's the best phone number and email address for us to reach you at?"]} loop={1} typeSpeed={40} />
              )}
              {/* <Typewriter words={["Got it. What's the best phone number and email address for us to reach you at?"]} loop={1} typeSpeed={40} />               */}
            </motion.p>

            <div className="flex lg:w-full zsm:w-[400px] flex-col lg:flex-row md:gap-8 md:justify-between justify-center">
              
              {/* Phone Number Input with Fade-Up & Typing Effect */}
              {showPhone && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                  className="flex w-full flex-col gap-y-2  vsm:my-6 md:my-0"
                >
                  <div className="flex justify-center">
                    <div>
                        <label htmlFor="phone" className="text-black font-medium text-sm mb-2 notranslate">
                        {flowLanguage == "Spanish" ? (
                          <Typewriter key={flowLanguage} words={["¿Cuál es tu número de teléfono?"]} loop={1} typeSpeed={40} />
                        ) : (
                          <Typewriter key={flowLanguage} words={["What is your phone number?"]} loop={1} typeSpeed={40} />
                        )}
                          {/* <Typewriter words={["What is your phone number?"]} loop={1} /> */}
                        </label>
                        {/* <input
                          type="tel"
                          id="phone"
                          className="w-full max-w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          placeholder="(555) 555-5555"
                        /> */}                        
                        <div className="w-full flex gap-3">
                          <CustomSelect countryCodeCountry={countryCodeCountry}
                              hanldeSetCountryCodeCountry={hanldeSetCountryCodeCountry} handleSelectCountryCode={handleSelectCountryCode}
                              countryCodes={countryCodes} countryCode={countryCode} AddCountryCode={AddCountryCode} />

                            <input
                              type="string"
                              className="w-full max-w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                              placeholder="+123 456 7890"
                              id="phoneNumber"
                              name="phone_number"
                              value={phone}
                              onChange={handleInputChange}
                              disabled={disable}
                            // ref={phoneInputRef}
                            />
                          </div>
                      </div>
                  </div>
                </motion.div>
              )}


              {/* Email Address Input with Fade-Up & Typing Effect */}
              {showEmail && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                  className="flex w-full flex-col gap-y-2"
                >
                  <div className="flex justify-center">
                    <div>
                      <label htmlFor="email" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["¿Cuál es tu dirección de correo electrónico?"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["What is your email address?"]} loop={1} typeSpeed={40} />
                      )}
                        {/* <Typewriter words={["What is your email address?"]} loop={1} /> */}
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="w-full border-2 max-w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="example@email.com"
                      />
                      
                    </div>
                  </div>
                </motion.div>
              )}

            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 vsm:px-6 sm:px-8 rounded-md notranslate" key={flowLanguage}
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {flowLanguage == "Spanish" ? (
                        "ANTERIOR"
                      ) : (
                        "PREVIOUS"
                      )}
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4  px-6 rounded-md notranslate" key={flowLanguage}
                  >
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>

      </div>
      <ToastContainer />
    </div>
    
    {verificationModal}
    {MailverificationModal}
    </>
  );
}
